import Vue from 'vue';
import ReInitPaymentButton from './components/ReInitPaymentButton';
import ReInitPaymentContainer from './components/ReInitPaymentContainer';
import SingleClickPaymentCheckbox from "./components/SingleClickPaymentCheckbox";

Vue.component('mollie-re-init-payment-btn', ReInitPaymentButton);
Vue.component('mollie-re-init-payment-container', ReInitPaymentContainer);
Vue.component('mollie-single-click-payment-checkbox', SingleClickPaymentCheckbox);

if (sessionStorage.getItem('mollieApplePayChecked') !== 'true') {

    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        // Add ApplePay to the method selection in your checkout
        $.ajax(
            {
                type: 'PUT',
                url: '/rest/mollie/activate_apple_pay',
            }
        )
            .done(
                function () {
                    console.log('apple pay active');
                }
            )
            .fail(
                function (msg) {
                }
            );
    }

    sessionStorage.setItem('mollieApplePayChecked', 'true');
}



// WEBPACK FOOTER //
// ./src/main.js